function save(sess, document, courseId) {
    const { LibraryDocument, Course } = sess;
    const course = Course.withId(String(courseId));
    if (course === null) {
        throw new Error(`there is not any course with this "${courseId}" id`);
    }
    return LibraryDocument.create({
        ...document,
        course
    });
}

export default {
    save
};
